export const TTRSLO = 3000;
export const TTISLO = 4000;

// items query
export const WAITING_FOR_BE_DATA_TIMING_KEY = 'timeWaitingForBackendData';
export const REQUEST_START = 'REQUEST_START';
export const REQUEST_END = 'REQUEST_END';

// availableFieldsQuery
export const AVAILABLE_FIELDS_QUERY_TIMING_KEY = 'jwm-availableFieldsQuery';
export const AVAILABLE_FIELDS_QUERY_START = 'AVAILABLE_FIELDS_QUERY_START';
export const AVAILABLE_FIELDS_QUERY_END = 'AVAILABLE_FIELDS_QUERY_END';

// UI Render time - the time between BE query finishes until TTI event
export const UI_RENDER_TIMING_KEY = 'jwm-ui-render-time';
export const UI_RENDER_START = 'UI_RENDER_START';
export const UI_RENDER_END = 'UI_RENDER_END';
